import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

type Tone = 'info' | 'primary' | 'success' | 'warning' | 'neutral';
const tones: Record<Tone, string> = {
  info: 'border-info/20 bg-info/8 text-blue-800 dark:text-blue-200',
  primary:
    'border-primary/20 bg-primary/8 text-violet-800 dark:text-violet-200',
  success: 'border-success/25 bg-success/8 text-green-800 dark:text-green-200',
  warning: 'border-warning/25 bg-warning/8 text-amber-900 dark:text-amber-200',
  neutral: 'border-border/70 bg-muted/45 text-muted-foreground',
};

/** Search-only chip scale; other screens keep their own badge density. */
export function SearchTypeChip({
  label,
  tone = 'neutral',
}: {
  label: string;
  tone?: Tone;
}) {
  return (
    <Badge
      variant="outline"
      className={cn(
        'h-[22px] rounded px-1.5 py-0 text-[11px] font-medium leading-none',
        tones[tone],
      )}
    >
      {label}
    </Badge>
  );
}

export function SearchSecurityTypeChip({ type }: { type?: string }) {
  if (!type || type === 'Unknown') return null;
  const label =
    type === 'Stock' ? 'Equity' : type === 'Depositary Receipt' ? 'DR' : type;
  const tone: Tone =
    type === 'Stock' || type === 'Equity'
      ? 'info'
      : type === 'ETF' || type === 'Mutual Fund'
        ? 'primary'
        : type === 'Depositary Receipt'
          ? 'success'
          : type === 'CFD'
            ? 'warning'
            : 'neutral';
  return <SearchTypeChip label={label} tone={tone} />;
}
